import load from '../../load';
import getUser from './actions/getUser';
import userError from './actions/userError';

const requestId = 'requestUser';

export { requestId };

export function requestUser() {
  return load(requestId, getUser, userError);
}

export default {
  requestUser,
};
